import { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { ConfirmButton, Field, inputCls } from "../../components/admin/fields";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [invite, setInvite] = useState({ name: "", email: "", role: "editor" });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const load = () => api.get("/admin/users").then((res) => setUsers(res.data || [])).catch((e) => setError(formatApiError(e)));
  useEffect(load, []);

  const sendInvite = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");
    try {
      await api.post("/admin/users", invite);
      setMsg(`Invitation sent to ${invite.email} — they set their own password from the email link.`);
      setInvite({ name: "", email: "", role: "editor" });
      load();
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <div className="max-w-3xl" data-testid="admin-users">
      <h1 className="h-condensed text-4xl">Users</h1>

      <form onSubmit={sendInvite} className="mt-8 space-y-5 border border-charcoal p-6">
        <h2 className="eyebrow text-[0.65rem]">Invite a user</h2>
        <div className="grid gap-5 sm:grid-cols-3">
          <Field label="Name">
            <input required value={invite.name} onChange={(e) => setInvite({ ...invite, name: e.target.value })} className={inputCls} data-testid="invite-name" />
          </Field>
          <Field label="Email">
            <input required type="email" value={invite.email} onChange={(e) => setInvite({ ...invite, email: e.target.value })} className={inputCls} data-testid="invite-email" />
          </Field>
          <Field label="Role">
            <select value={invite.role} onChange={(e) => setInvite({ ...invite, role: e.target.value })} className={inputCls} data-testid="invite-role">
              <option value="editor">Editor</option>
              <option value="admin">Admin</option>
            </select>
          </Field>
        </div>
        <button type="submit" className="border border-charcoal bg-charcoal px-6 py-2.5 font-condensed text-xs font-semibold uppercase tracking-[0.14em] text-offwhite" data-testid="invite-submit">
          Send invitation
        </button>
        {msg && <p className="text-xs font-light opacity-70" data-testid="invite-success">{msg}</p>}
        {error && <p className="text-xs" role="alert" data-testid="users-error">{error}</p>}
      </form>

      <div className="mt-10 border-t border-charcoal">
        {users.map((u) => (
          <div key={u.id} className="flex flex-wrap items-center gap-4 border-b border-charcoal py-4" data-testid={`user-row-${u.id}`}>
            <div className="min-w-0 flex-1">
              <p className="h-condensed truncate text-lg">{u.name}</p>
              <p className="truncate text-xs font-light opacity-60">{u.email}</p>
            </div>
            <select
              value={u.role}
              onChange={async (e) => {
                await api.put(`/admin/users/${u.id}`, { role: e.target.value });
                load();
              }}
              className={`${inputCls} w-32`}
              data-testid={`user-role-${u.id}`}
            >
              <option value="editor">Editor</option>
              <option value="admin">Admin</option>
            </select>
            <button
              type="button"
              onClick={async () => {
                await api.put(`/admin/users/${u.id}`, { active: !u.active });
                load();
              }}
              className="link-arrow text-xs"
              data-testid={`user-active-${u.id}`}
            >
              {u.active ? "Deactivate" : "Reactivate"}
            </button>
            <ConfirmButton
              label="Remove"
              testid={`user-delete-${u.id}`}
              onConfirm={async () => {
                try {
                  await api.delete(`/admin/users/${u.id}`);
                  load();
                } catch (err) {
                  setError(formatApiError(err));
                }
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
